import getBasePath from '@/utils/path'
import ExtendedLegacyApi from './ExtendedLegacyApi'

let basePath = getBasePath() + '/moe-auth'

export function createLegacyApi (): ExtendedLegacyApi {
  return new ExtendedLegacyApi({ basePath })
}
